import { html, ref, when } from '@microsoft/fast-element';
import { CASCADE_ENUM } from '../../../../../services/enum.service';
import { continueArrowIcon, starUnHighlightedIcon } from '../../../../../styles';
import { formatDateLong, getFormattedNumber, getPriceValue } from '../../../../../utils/formatting';
import { AnalyticsSummaryTableColumn } from './summary-table-column';
import { PRODUCT_TYPE, PROJECT_OPERATIONAL_STATUS } from '../../../../../utils';

export const AnalyticsSummaryTableColumnTemplate = html<AnalyticsSummaryTableColumn>`
  <div
    class="
                  ${(x) => (x.isFirst ? 'first-header' : '')}
                  ${(x) => (x.isLast ? 'last-header' : '')}"
  >
    <span>${(x) => x.data.UNIQUE_ID}-${(x) => x.data.PROJECT_NAME}</span>
    <zero-button
      ${ref('favoriteBtn')}
      class="favorite-icon"
      type="button"
      disabled
      @click=${(x) => x.favoriteWatchlistVppa()}
    >
      ${starUnHighlightedIcon()}
    </zero-button>
  </div>
  <div>${(x) => x.data.SELLER}</div>
  <div>${(x) => x.data.PROJECT_NAME}</div>
  <div>${(x) => x.enumService.getEnumTranslation(CASCADE_ENUM.TECHNOLOGY, x.data.TECHNOLOGY)}</div>
  <div>${(x) => (x.data.COUNTY ? x.data.COUNTY + ', ' : '') + x.data.STATE}</div>
  <div>
    ${(x) =>
      x.data.NAMEPLATE_CAPACITY ? getFormattedNumber(x.data.NAMEPLATE_CAPACITY, '', 0) + ' MW' : ''}
  </div>
  <div>
    ${(x) => (x.data.BUYERS_FRACTION ? getFormattedNumber(x.data.BUYERS_FRACTION) + '%' : '')}
  </div>
  <div>${(x) => x.data.ISO}</div>
  ${when(
    (x) => x.buyerAnalyticsService.currentPreferences.PRODUCT_TYPE !== PRODUCT_TYPE.RECS,
    html`
      <div>
        ${(x) => x.data.SETTLEMENT_POINT}
      </div>
      <div>
        ${(x) => x.data.SETTLEMENT_INDEX}
      </div>
    `
  )}
  <div>${(x) => formatDateLong(x.data.TENOR_START_DATE)}</div>
  <div>${(x) => x.data.TENOR_MONTHS}</div>
  <div>
    ${(x) =>
      x.enumService.getEnumTranslation(
        CASCADE_ENUM.ALTERNATIVE_SWAP_SETTLEMENT_CALCULATION_METHOD,
        x.data.SWAP_SETTLEMENT_CALCULATION_METHODS
      )}
  </div>
  <div>${(x) => getPriceValue(getFormattedNumber(x.data.FIXED_PRICE), '')}</div>
  <div>${(x) => getFormattedNumber(x.data.REFERENCED_EXPECTED_SETTLEMENT, '', 2, '$')}</div>
  <div>${(x) => getFormattedNumber(x.data.REFERENCED_LME, '', 2)}</div>
  <div>${(x) => getFormattedNumber(x.data.REFERENCED_IMPLIED_CARBON_PRICE, '', 2, '$')}</div>
  <div>${(x) => x.data.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.OPERATIONAL ? 0 : 1}</div>
  <div>
    ${(x) =>
      x.enumService.getEnumTranslation(
        CASCADE_ENUM.APPLICABLE_REC_PROGRAM,
        x.data.APPLICABLE_REC_PROGRAM
      )}
  </div>
  <div>
    ${(x) =>
      x.enumService.getEnumTranslation(
        CASCADE_ENUM.PERFORMANCE_GUARANTEE_METHOD,
        x.data.PERFORMANCE_GUARANTEE_METHOD
      )}
  </div>
  <div>${(x) => x.data.UNIQUE_ID}</div>
  <div>
    ${(x) =>
      x.enumService.getEnumTranslation(
        CASCADE_ENUM.FORM_AGREEMENT_TYPE,
        x.data.FORM_AGREEMENT_TYPE
      )}
  </div>
  <div>
    ${(x) => x.enumService.getEnumTranslation(CASCADE_ENUM.CONTRACT_TYPE, x.data.CONTRACT_TYPE)}
  </div>
  <div
    class="
      ${(x) => (x.isFirst ? 'first-footer' : '')}
      ${(x) => (x.isLast ? 'last-footer' : '')}"
  >
    <zero-button
      class="market-depth-btn"
      appearance="primary"
      @click=${(x) => x.navigateToMarketDepth()}
    >
      View in Market Depth ${continueArrowIcon()}
    </zero-button>
  </div>
`;
